define([
    "dojo/_base/declare",
    "csi/view/PrintController"
], function(declare,PrintController) {

    return declare(PrintController, {
		/**
		 * Refresh data if NewlyCreated group exists
		 */
		onPreActionDeferreds: function(dfds) {
			dfds.push(this.widget.refreshDataIfNewlyCreated());
		}
    });
});
